module.exports = "https://img.zhijierongxing.com/saas/img/menu2.004cb6a1.png";